module.exports = __webpack_public_path__ + "img/0014.133e2e1b.jpg";